import type {AiChatGeneratedAsset, AiChatGeneratedAssetFilter} from '@AiChat/ai-chat.types';

export const AI_CHAT_GENERATED_ASSET_ADDED_EVENT = 'ai-chat-generated-asset-added';
export const AI_CHAT_GENERATED_ASSET_ADDED_CHANNEL = 'ai-chat-generated-asset-added-channel';

export const getGeneratedAssets = async (filter: AiChatGeneratedAssetFilter, limit: number, offset: number): Promise<AiChatGeneratedAsset[]> => {
  return (await window.PMW.readLocal('ai/getGeneratedAssets', {filter, limit, offset})) as AiChatGeneratedAsset[];
};

export const hasAnyGeneratedAssets = async (): Promise<boolean> => {
  return (await window.PMW.readLocal('ai/hasGeneratedAssets')) as boolean;
};

export const getShouldShowAssetsIntroSubtitle = async (): Promise<boolean> => {
  const result = (await window.PMW.readLocal('ai/shouldShowAssetsIntroSubtitle')) as {shouldShow: boolean};
  return result.shouldShow;
};

export const recordAssetsIntroSubtitleView = async (): Promise<boolean> => {
  const result = (await window.PMW.writeLocal('ai/recordAssetsIntroSubtitleView', {})) as {shouldShow: boolean};
  return result.shouldShow;
};

/**
 * Announces a newly materialised asset to the chat, in the current tab and in any other one.
 *
 * The broadcast is what reaches the chat when the asset is materialised somewhere else: the desktop publish
 * flow does that work in a separate pending tab which then navigates itself to the wizard, so a same-window
 * event alone dies with that tab and the chat never reveals its generated-assets entry.
 */
export const dispatchAiChatGeneratedAssetAdded = (): void => {
  window.dispatchEvent(new CustomEvent(AI_CHAT_GENERATED_ASSET_ADDED_EVENT));

  const broadcastChannel = new BroadcastChannel(AI_CHAT_GENERATED_ASSET_ADDED_CHANNEL);
  broadcastChannel.postMessage(AI_CHAT_GENERATED_ASSET_ADDED_EVENT);
  broadcastChannel.close();
};
